import React from 'react'

import { useFeatureFlagHook } from './useFeatureFlagHook'

type FeatureFlagContextType = {
  status: string
  features: Record<string, boolean>
  getFeatureByKey: (key: string) => boolean
}

export const FeatureFlagContextDefaultValue: FeatureFlagContextType = {
  status: 'loading',
  features: {},
  getFeatureByKey: () => false,
}

export const FeatureFlagContext = React.createContext(
  FeatureFlagContextDefaultValue
)

FeatureFlagContext.displayName = 'FeatureFlagContext'

export function useFeatureFlagContext() {
  const context = React.useContext(FeatureFlagContext)
  if (context === undefined) {
    throw new Error(
      'FeatureFlagContext must be used within a FeatureContextProvider'
    )
  }
  return context
}

export function WithFeatureFlagContext(props: any) {
  const featureFlag = useFeatureFlagHook()

  return <FeatureFlagContext.Provider value={featureFlag} {...props} />
}
